var replaceSizeImage = function replaceSizeImage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    imgHeight = _ref.imgHeight,
    src = _ref.src,
    imgWidth = _ref.imgWidth;
  if (!src) return undefined;
  return src.replace('{w}', imgWidth).replace('{h}', imgHeight);
};
export default replaceSizeImage;